// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Skeleton, Text } from '@mantine/core';
import { FC, useEffect, useState } from 'react';
import { fetchEmailsHead } from '../../Service/restapi/messageService';

const EmailBoxCounter: FC<{ box: string; filter?: string; contactIds?: number[] }> = ({ box, filter, contactIds }) => {
  const [count, setCount] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchEmailsHead(box, filter, null, contactIds)
      .then((resp) => {
        const total = resp.headers.get('X-Total-Count');
        if (total) {
          setCount(parseInt(total, 10));
        }
      })
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Skeleton height={20} circle visible={loading}>
      <Text size="xs" color="dimmed" align="center">
        {count}
      </Text>
    </Skeleton>
  );
};

export default EmailBoxCounter;
